import Router from "next/router";

import { Button, Stack, Typography } from "@mui/material";
import { CirclesFour } from "@phosphor-icons/react";

import { DefaultRedeemPartnerCarousel } from "../DefaultRedeemPartnerCarousel";
import { styles } from "./styles";
import { CrossSellSectionProps } from "./types";

export const CrossSellSection: React.FC<CrossSellSectionProps> = ({ cards, title, categoryName, partnerName }) => {
  if (!cards?.length) {
    return null;
  }

  return (
    <Stack css={styles.container}>
      <Stack css={styles.header_container}>
        <Typography css={styles.title}>
          {title || "Conheça outros parceiros na categoria"}{" "}
          <Typography css={styles.category} component="span">
            {categoryName ?? ""}
          </Typography>
          .
        </Typography>

        <Button
          variant="outlined"
          css={styles.button}
          startIcon={<CirclesFour size={24} color="#0045B5" />}
          onClick={() => {
            Router.push(`/categorias`);
          }}
        >
          Confira todas as categorias
        </Button>
      </Stack>

      <DefaultRedeemPartnerCarousel
        cards={cards}
        carouselName="crossSellSection"
        paginationBullet="#00386380"
        paginationBulletActive="#FFD41C"
        partnerName={partnerName}
      />
    </Stack>
  );
};
